import { Link } from 'react-router-dom';
import _ from 'lodash';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Tooltip, Modal, message } from 'antd';
import moment from 'moment';
import ReactTable from 'react-table';
import 'react-table/react-table.css';
// import { BarLoader } from 'react-spinners';


import { 
    fetchAllBlogs,
    deleteBlog
} from '../../actions/Blog';
import Status from '../../components/Status';

const $ = window.$;
const confirm = Modal.confirm;

class Blogs extends Component {

    constructor(props) {
        super(props);

        this.state = {
            filteredBlogs: {},
            selectedStatusIndex: -1
        };
    }

    componentDidMount() {

        // $('#blog-list').DataTable({
        //     searching: false,
        //     info: false,
        //     language: {
        //         "sDom": 'Rfrtlip',
        //         "lengthMenu": "Display _MENU_ Entries",
        //         paginate: {
        //             previous: '<<',
        //             next: '>>',
        //         }
        //     },
        //     "dom": '<"top"f>rt<"bottom"ilp><"clear">',
        //     fixedColumns: true,
        //     bAutoWidth: false,
        //     columnDefs: [{
        //         width: 400,
        //         targets: 0
        //     },
        //     {
        //         width: 400,
        //         targets: 1
        //     },
        //     {
        //         width: 300,
        //         targets: 2
        //     },
        //     {
        //         width: 150,
        //         targets: 3
        //     }
        //     ],
        // });

        this.props.fetchAllBlogs();
    }

    componentDidUpdate(prevProps, prevState) {

        // $(function () {
        //     $('[data-toggle="tooltip"]').tooltip();
        // });

        $(".sort-dropdown").on('click', 'li a', function () {
            $(".btn.sort-list:first-child").text($(this).text());
            $(".btn.sort-list:first-child").val($(this).text());
        });
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.blogs) {
            this.setState({ filteredBlogs: nextProps.blogs });
        }
    }

    onSelectStatus(status) {
        this.setState({ selectedStatusIndex: status });
    }

    onDeleteClick(blog) {

        confirm({
            title: 'Are you sure you want to delete this blog?',
            content: `"${blog.title_en}"`,
            okText: 'Yes',
            okType: 'danger',
            cancelText: 'No',
            onOk: () => {
                console.log('OK');

                // perform delete
                const hideLoading = message.loading('Deleting Blog...', 0);

                this.props.deleteBlog(blog.id, (success) => {

                    hideLoading();

                    if (success) {
                        message.success('Blog Deleted', 2.5);
                    } else {
                        message.error('Error Deleting Blog', 2.5);
                    }
                });
            }
        });

    }

    renderStatusDropdown() {
        return (
            <div className="form-group dropdown sort-dropdown">
                <button
                    className="btn dropdown-toggle sort-list"
                    type="button"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                >
                    All Status
                </button>
                <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton">
                    <li>
                        <a className="dropdown-item" onClick={() => this.onSelectStatus(-1)}>All Status</a>
                    </li>
                    <li>
                        <a className="dropdown-item" onClick={() => this.onSelectStatus(0)}>Published</a>
                    </li>
                    <li>
                        <a className="dropdown-item" onClick={() => this.onSelectStatus(1)}>Unpublished</a>
                    </li>
                </ul>
            </div>
        );
    }

    renderBlogs() {
        const { filteredBlogs, selectedStatusIndex } = this.state;

        // filter

        const rows = _.map(filteredBlogs, (blog, key) => {

            if (selectedStatusIndex === 0 && blog.status !== 0) {
                // published
                return;
            } else if (selectedStatusIndex === 1 && blog.status !== 1) {
                // unpublished
                return;
            }

            return (
                <tr key={key}>
                    <td>{blog.title_en}</td>
                    <td>{moment(blog.createdAt).format('D MMM YYYY, HH:mm')}</td>
                    <td>
                        {blog.status === 0 ? <Status color="green" title="Published" /> : <Status color="red" title="Unpublished" />}
                    </td>
                    <td className="align-center">
                        <Link
                            to={`/blogs/${key}`}
                            className="btn btn-tooltip"
                            data-toggle="tooltip"
                            data-placement="top"
                            title="Edit"
                        >
                            <img src="/resources/img/ic-edit.png" alt="Edit" data-toggle="modal" />
                        </Link>
                        <button
                            className="btn btn-tooltip"
                            data-toggle="tooltip"
                            data-placement="top"
                            title="Delete"
                            onClick={() => this.onDeleteClick(blog)}
                        >
                            <img src="/resources/img/ic-delete.png" alt="Delete" />
                        </button>
                    </td>
                </tr>
            );
        })

        return (
            <tbody>
                {rows}
            </tbody>
        );
    }

    renderActions(blog) {
        return (
            <div className="align-center">
                <Tooltip title="Edit">
                    <Link
                        to={`/blogs/${blog.id}`}
                        className="btn btn-tooltip"
                    >
                        <img src="/resources/img/ic-edit.png" alt="Edit" />
                    </Link>
                </Tooltip>
                <Tooltip title="Delete">
                    <button className="btn btn-tooltip" onClick={() => this.onDeleteClick(blog)}>
                        <img src="/resources/img/ic-delete.png" alt="Delete" />
                    </button>
                </Tooltip>
            </div>
        );
    }

    renderTable() {
        const { filteredBlogs, selectedStatusIndex } = this.state;

        console.log(filteredBlogs);

        const blogs = _.toArray(filteredBlogs);

        return (
            <ReactTable
                data={blogs}
                columns={[
                    {
                        Header: 'Blogs',
                        id: 'blogs',
                        accessor: d => <div>{d.title_en}</div>
                    },
                    {
                        Header: 'Create Date',
                        id: 'createDate',
                        accessor: d => moment(d.createdAt).format('D MMM YYYY, HH:mm'),
                        width: 150
                    },
                    {
                        Header: 'Status',
                        id: 'status',
                        accessor: d => d.status === 0 ? <Status color="green" title="Published" /> : <Status color="red" title="Unpublished" />,
                        width: 120
                    },
                    {
                        Header: '',
                        id: 'actionButtons',
                        className: 'col-center',
                        accessor: d => this.renderActions(d),
                        width: 60
                    }
                ]}
                defaultPageSize={10}
                className="-highlight"
            />
        );
    }

    render() {
        const { isBlogLoading } = this.props;

        return (
            <div className="main-content">
                <div className="page-title">Blogs</div>
                <div className="divider"/>
                {/* <div style={{ zIndex: 10 }}>
                    <BarLoader loading={true} color={'#455963'} height={2} />
                </div> */}
                <div className="function blogs">
                    <div className="row">
                        <div className="col-md-auto">
                            <div className="input-group search-box">
                                <input type="text" className="form-control" placeholder="Search..." name="search-box" />
                            </div>
                        </div>
                        <div className="col-md-auto">
                            {this.renderStatusDropdown()}
                        </div>
                        <div className="col-md-auto" style={{ width: '37.2%' }}></div>
                        <div className="col-md-auto">
                            <Link to={`/blogs/new`} className="btn button green-btn btn-link">+ New Blog</Link>
                        </div>
                    </div>
                </div>
                {this.renderTable()}
                {/* <table id="blog-list" className="table table-list hover" cellSpacing="0" width="100%">
                    <thead>
                        <tr>
                            <th>Blogs</th>
                            <th>Create Date</th>
                            <th>Status</th>
                            <th></th>
                        </tr>
                    </thead>
                    {this.renderBlogs()}
                </table> */}
            </div>
        )
    }
}

function mapStateToProps(state) {
    const { blogs, isBlogLoading } = state.blog;

    return { blogs, isBlogLoading };
}

export default connect(mapStateToProps, { 
    fetchAllBlogs,
    deleteBlog 
})(Blogs);


// WEBPACK FOOTER //
// ./src/views/blogs/index.js